import React from 'react';
import { COLORS } from "Constants/BIDashboardConstants"

const LeftArrowIcon = ({ disabled }) => {
  return (
    <svg style={{ transform: 'rotate(-90deg)', border: `1px solid ${COLORS.oneGp.smoke}`, backgroundColor: 'white', transformOrigin: '50 % 50 %' }} aria-hidden="true" focusable="false" width="40" height="40" data-prefix="fal" data-icon="angle-left" className="svg-inline--fa fa-angle-up fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill={disabled ? COLORS.oneGp.smoke : COLORS.oneGp.globalBlue} d="M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z"></path></svg>
  ); 
};

export default LeftArrowIcon;
